import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { PluginsService } from '../../services/plugins.service';
import $ from 'jquery';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactFormService } from '../../services/contact-form.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  imagesUrl = environment.imagesUrl;

  public navLogo: string = this.imagesUrl + 'logo-black.png';
  public footerLogo: string = this.imagesUrl + 'logo-white.png';
  public logoWhite: string = this.imagesUrl + 'logo-black.png';
  public logoClass: string = "logo";
  footerText: string = '';
  footerTitle: string = 'מוזמנים להצטרף אלינו';
  footerDescription: string = 'הצרפו לשירות הניוזלייטר שלנו ותתעדכנו בזמן אמת על התכנים המיוחדים בתחום השילוט הדיגיטלי';


  headerText1 = 'נעים להכיר, דיגיטל לובי';
  headerText2 = 'חברת שילוט דיגיטלי';
  text1 = 'עם יותר מ-1,000 מסכים ברחבי הארץ. דיגיטל לובי הוקמה במטרה לתת מענה זמין, נוח ומרשים לשילוט בבנייני מגורים ובתי עסק. .';
  text2 = 'השאירו פרטים ונדאג לשדרג לכם את החלל הרצוי';
  videoUrl = 'introduce/introduce-screen.mp4';
  imageUrl = 'introduce/poster-screen.png';

  public navItems: any = [
    {
      href: '#iq-home', title: 'עמוד הבית',
      _is_active: true
    },
    { href: '#iq-service', title: 'שירותינו' },
    { href: '#whyUs', title: 'למה אנחנו' },
    { href: '#testimonials', title: 'הלקוחות שלנו' },
    { href: '#iq-contact', title: 'צרו קשר' }
  ];
  titleSectionProp: any = {
    title: 'מוזמנים ליצור איתנו קשר',
    description: ''
  };

  sectionProp: any = {
    class: 'pt-0 text-right',
    id: 'iq-contact'
  }
  contactDetail: any = {
    logo: this.imagesUrl + 'logo-black.png',
    address: 'נחל שניר 19 אשדוד',
    number: '054-560-2139',
    mail: 'sales@dlobby.co.il'
  };
  contactForm = new FormGroup({
    fullName: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    mail: new FormControl(''),
    subject: new FormControl('', Validators.required),
    message: new FormControl(''),
  });
  constructor(private plugins: PluginsService, private meta: Meta, private title: Title, private contactFormService: ContactFormService) {
    this.meta.addTags([
      { name: 'keywords', content: 'מסכים דיגיטליים, מסך ללובי, מסך לעסק, עסק דיגיטלי, שליטה מרחוק' },
      { name: 'author', content: 'דיגיטל לובי' },
      { name: 'description', content: 'דיגיטל לובי מתמחה בשירותי שילוט דיגיטלי לכל מטרה. אנו מספקים שירותים לעסקים, משרדים, בנייני משרדים ובנייני מגורים' },

    ])
    this.title.setTitle('דיגיטל לובי - שילוט דיגיטלי לעסקים ובניינים')
  }

  ngOnInit() {

    const current = this;
    setTimeout(function () {
      current.plugins.index();
    }, 200);
  }
  // sendMessage() {
  //   // console.log(this.contactForm.value)
  //   const model = {
  //     pageName: "Home page",
  //     name: this.contactForm.value.fullName||'test',
  //     mail: this.contactForm.value.mail||'test',
  //     phone: this.contactForm.value.phone||'test',
  //     content: "subjcet: " + this.contactForm.value.subject + "  content:  " + this.contactForm.value.message
  //   }
  //   this.contactFormService.sendMail(model).subscribe(res => {
  //     console.log(res);
  //   })
  // }
  sendMessage() {

  }
  jumpTo(href) {
    $('html, body').stop().animate({
      scrollTop: $(href).offset().top
    }, 1500);
  }

}
